module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/revert-circle-18bee5a806dc583f776ea71b33ce6692.svg";